import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteProps, Redirect } from 'react-router';
import { AppState } from '../../..';
import { NotFoundComponent } from '@common/components/not-found/not-found.component';
import { BaseService } from '@services/BaseService';
import { Role } from '@models/Roles';
import { RouteDefinitions } from '@common/route-definitions';

interface AuthRouteProperties extends RouteProps {
  readonly allowedRoles: string[];
}

interface AuthRouteComponentProperties extends AuthRouteProperties {
  readonly userId?: number;
  readonly userRoles?: string[];
}

class AuthRouteComponent extends React.Component<AuthRouteComponentProperties> {
  render() {
    return this.props.userRoles && Role.CheckRoles(this.props.allowedRoles) ? (
      <Route {...this.props} />
    ) : this.props.userId && this.props.userRoles ? (
      <NotFoundComponent />
    ) : (
      <Redirect to={RouteDefinitions.login} />
    );
  }
}

function mapStateToProps(state: AppState, ownProps: AuthRouteProperties): Partial<AuthRouteComponentProperties> {
  return {
    userId: state.auth.currentProfile ? state.auth.currentProfile.id : (BaseService.getProfileJSON()! || {}).id,
    userRoles: state.auth.currentProfile
      ? state.auth.currentProfile.roles
      : (BaseService.getProfileJSON()! || {}).roles,
    ...ownProps
  };
}

export const AuthRoute = connect(mapStateToProps)(AuthRouteComponent);



// WEBPACK FOOTER //
// ./src/common/components/auth-route/index.tsx